import {
    Component,
    inject,
    OnInit,
    TemplateRef,
    ViewChild,
  } from '@angular/core';
  import { PAGE_CONSTANTS } from '../../../../shared/constants/page.constants';
  import {
    STATIC_DATA,
    STATIC_JSON_DATA_PATH,
  } from '../../../../shared/constants/static-data.constants';
  import { ListTableComponent } from '../../../../shared/components/list-table/list-table.component';
  import { Router, ActivatedRoute } from '@angular/router';
  import { ClaimsService } from '../../../../services/claims.service';
  import { SharedDataService } from '../../../../shared/services/shared-data-service';
  import { BillingService } from '../../../../services/billing.service';
  import { ListService } from '../../../../shared/services/list.service';
  import { DatePipe } from '@angular/common';
  import { PageConfig } from '../../../../shared/authorization/auth.config';
  import { AuthorizationUtility } from '../../../../shared/authorization/auth.utility';
  import { AuthorizationService } from '../../../../shared/authorization/authorization.service';
  import { BillingFilterComponent } from '../../billing-filter/billing-filter.component';
  import { UserService } from '../../../../services/user.service';
  import { LoggerService } from '../../../../shared/services/logger.service';
  import { SectionsService } from '../../../../services/sections.service';
  
  @Component({
    selector: 'ppl-recon-files-list',
    standalone: true,
    imports: [ListTableComponent, BillingFilterComponent],
    templateUrl: './workday-payment-list.component.html',
    styleUrl: './workday-payment-list.component.css',
  })
  export class WorkdayPaymentListComponent implements OnInit {
    sharedDataKey: string = STATIC_DATA.SHARED_RECON_FILES_DATA;
    pageId: string = PAGE_CONSTANTS.RECON_FILES_GRID_PAGE;
    columnsToBeHidden: string[] = [];
    actionsToBeHidden: string[] = [];
    isPageRestrictionLoaded = false;
    programName!: string;
    lazyLoad = true;
    appliedFilters: any;
    workdayList: any[] = [];
  
    @ViewChild(ListTableComponent) childComponent!: ListTableComponent;
  
    fields = [
      { field: 'enrichedBatchId', show: true },
      { field: 'fileName', show: true },
      { field: 'workdayRunId', show: true },
      { field: 'payerId', show: true },

    ];
    cols = [];
  
    constructor(
      private router: Router,
      private listService: ListService,
      private billingService: BillingService,
      private datePipe: DatePipe,
      private sharedDataService: SharedDataService,
      private route: ActivatedRoute,
      private authService: AuthorizationService,
      private authUtility: AuthorizationUtility,
      private userService: UserService,
      private logger: LoggerService,
      private sectionService: SectionsService
    ) {}
  
    ngOnInit(): void {
      const selectedProgram = this.userService.getSelectedProgram();
      this.programName = selectedProgram?.program_code ?? '';
      const navigationState = window.history.state;
      this.getColumnData();
      if (navigationState.fileId) {
        const { fileId } = navigationState;
        const filters = [];
        console.log(fileId);
        filters.push({
          jsonPath: 'fileId',
          value: fileId,
          operator: 'equal',
        });
        this.searchWorkdayList(filters);
      } else {
        console.log('No state data available');
      }
    }
  
    async getColumnData() {
      try {
        const tempCols = await this.sectionService.getJsonConfigurationData(
          STATIC_JSON_DATA_PATH.WORKDAY_PAYMENT_LIST_PAGE_HEADERS,
          'billing'
        );
        this.cols = tempCols.columns;
      } catch (e) {
        this.logger.debug('Error in getting column data', e);
      }
    }
  
    getInitData() {
        const searchParam = [
          {
            jsonPath: 'batchFileTypeLkp',
            value: 'WORKDAY_PAYMENT',
            operator: 'equal',
          },
        ];
        this.searchWorkdayList(searchParam);
      }
  
    onSearch(filters: any) {
      this.appliedFilters = filters;
      this.searchWorkdayList(filters);
    }
  
    buildRequestPayload(
      pageName: string,
      orderBy: string,
      searchParams: [],
      startingPageNumber = 1
    ) {
      const payload: any = {
        pageName: pageName,
        programCode: this.programName,
        condition: 'and',
        recordsPerPage: 20,
        startingPageNumber: startingPageNumber,
        searchParam: searchParams,
        orderByColumn: orderBy ? [orderBy] : [],
        orderBy: ['desc'],
      };
      return payload;
    }
  
    searchWorkdayList(filters: any, startingPageNumber = 1, currentPage = 0) {
      if (startingPageNumber == 1) {
        this.workdayList = [];
      }
      const processedPayload = this.buildRequestPayload(
        'billing-workday-payment-list',
        'createdDate',
        filters,
        startingPageNumber
      );
      this.listService
        .getListData(processedPayload, 'billing')
        .subscribe((data: any) => {
          const records = data.responsedata;
          records.forEach((element: any) => {
            element.createddate = this.datePipe.transform(
              element.createddate,
              'MM/dd/yyyy'
            );
          });
          if (startingPageNumber > 1) {
            this.workdayList = [...this.workdayList, ...records];
            this.childComponent.resetPagination(startingPageNumber, currentPage);
          } else {
            this.workdayList = records;
          }
        });
    }
  
    rowClicked(rowDetail: any) {
    }
  
    onPageLoad(event: any) {
      this.searchWorkdayList(
        this.appliedFilters,
        event.startingPageNumber,
        event?.first ?? 0
      );
    }
  
    clearData() {
      this.sharedDataService.clearData(this.sharedDataKey);
    }
  }
  